import { ICartesianSize } from "./Spacial/Cartesian";

export function isVerticalScrollbarVisible(): boolean
{
    // Compare the width of the viewport to the width of the document
    return document.documentElement.scrollHeight > window.innerHeight;
}

export function isHorizontalScrollbarVisible(): boolean
{
    // Compare the width of the viewport to the width of the document
    return document.documentElement.scrollWidth > window.innerWidth;
}


// Width of vertical scrollbar
export function scrollbarWidth(): number
{
    if (!isVerticalScrollbarVisible())
        return 0;
    
    // Create a temporary element
    const scrollDiv = document.createElement('div');
    addScollbarMeasurementStyles(scrollDiv);
    document.body.appendChild(scrollDiv);

    // Measure the width of the element with scrollbar
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Remove the temporary element
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
}

// Width of vertical scrollbar
export function scrollbarHeight(): number
{
    if (!isHorizontalScrollbarVisible())
        return 0;

    // Create a temporary element
    const scrollDiv = document.createElement('div');
    addScollbarMeasurementStyles(scrollDiv);
    document.body.appendChild(scrollDiv);

    // Measure the width of the element with scrollbar
    const scrollbarWidth = scrollDiv.offsetHeight - scrollDiv.clientHeight;

    // Remove the temporary element
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
}

// Apply styles to get the scroll width
function addScollbarMeasurementStyles(scrollDiv: HTMLDivElement)
{
    // Apply styles to get the scroll width
    scrollDiv.style.width = "100px";
	scrollDiv.style.height = "100px";
	scrollDiv.style.overflow = "scroll";
	scrollDiv.style.position = "absolute";
	scrollDiv.style.top = "-9999px";
}

// Get the viewport size
export function viewPortSize(removeScrollbarSize: boolean = true): ICartesianSize
{
    return { 
        width: window.innerWidth - scrollbarWidth(), 
        height: window.innerHeight - scrollbarHeight() };
}